export default [
    {"Year": 2001},
    {"Year": 2002},
    {"Year": 2003},
    {"Year": 2004},
    {"Year": 2005},
    {"Year": 2006},
    {"Year": 2007},
    {"Year": 2008},
    {"Year": 2009},
    {"Year": 2010},
    {"Year": 2011},
    {"Year": 2012},
    {"Year": 2013},
    {"Year": 2014},
    {"Year": 2015},
    {"Year": 2016},
    {"Year": 2017},
    {"Year": 2018},
    {"Year": 2019},
    {"Year": 2020},
    {"Year": 2021},
    {"Year": 2022}
]